<template>
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0">
      <ChromeSpeechToTextTextarea rows="4" max-rows="10" v-model="text" />
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>
    <div
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 check-text-right"
    >
      <v-btn v-if="$route.query.testToken" @click="testToken">testToken</v-btn>
      <ConfirmationDialog
        headerClass="modal-header"
        message-title="FINALIZAR?"
        :message-body="`Deseja realmente finalizar a evolução?`"
        open-text="FINALIZAR MANUAL COM ASSINATURA ELETRÔNICA"
        open-class="btn-notcertified"
        open-left-icon="fa-check"
        @yes="finish"
        :loading="loading"
        :disabled="loading"
      />
    </div>
  </div>
</template>

<script>
import ChromeSpeechToTextTextarea from "../Components/ChromeSpeechToTextTextarea";

import ConfirmationDialog from "../Components/ConfirmationDialog";

import ErrorsMessages from "../Components/ErrorsMessages";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import { digitalCertificate } from "../../lib/digital-certificate";

import { localizacaoAtual } from "../../lib/localizacaoAtual";

export default {
  name: "Create",

  components: {
    ChromeSpeechToTextTextarea,
    ConfirmationDialog,
    ErrorsMessages,
  },

  props: {
    resident_id: [String, Number],
    type: [String, Number],
  },

  data() {
    return {
      text: "",
      loading: false,
      errors: [],
    };
  },

  methods: {
    async testToken() {
      await api.post("/certificate/test-token");
    },

    async finish() {
      try {
        const retornoLocalizacaoAtual = await localizacaoAtual();

        // if (retornoLocalizacaoAtual.error) {
        //   alert(retornoLocalizacaoAtual.msg);
        //   return;
        // }

        let { latitude, longitude } = retornoLocalizacaoAtual;

        this.loading = true;

        const { resident_id, text, type } = this;

        let execute_certificate = false;

        if (
          this.$router.currentRoute.query.execute_certificate &&
          this.$router.currentRoute.query.execute_certificate == "execute"
        ) {
          execute_certificate = "execute";
        }

        let params = {
          execute_certificate,
          resident_id,
          text,
          type,
          latitude,
          longitude,
        };

        const response = await api.post("/rest-home/evolution", params);

        const { error, errors, message, item } = response.data;

        if (!error) {
          toast(message, "success");
          this.$bvModal.hide("modalCreate");
          this.$emit("success");
          this.text = "";
          this.errors = [];
          this.executeCertificate(item);
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async executeCertificate(item) {
      if (!item) {
        return;
      }

      let data = [
        {
          col1: {
            exist: true,
            text: item.table.text,
          },
          col2: {
            exist: false,
            text: "",
          },
          col3: {
            exist: false,
            text: "",
          },
          col4: {
            exist: false,
            text: "",
          },
        },
      ];

      await digitalCertificate({
        title: "EVOLUÇÃO - MÉDICA",
        data,
        exist_footer: false,
        item,
        created_at: item.table.created_at,
        signature: true,
      });
    },
  },
};
</script>
